export default function getResource(label, vars = []) {
    const resources = {
        basket: 'panier',
        checkout: 'Passer à la caisse',
        item: 'article',
        total: `Vous avez ${vars[0]} dans votre ${vars[1]}.`
    };

    return resources[label];
}
